import { useAppScrollRef } from '@doltech/core/lib/appScroll/withAppScroll';
import {
  InteractionBottomNavigation,
} from '@doltech/ui/lib/figma/Layout/Landing/BottomNavigation/InteractionBottomNavigation';
import {
  InteractionBottomNavigationProps,
} from '@doltech/ui/lib/figma/Layout/Landing/BottomNavigation/InteractionBottomNavigationBase';
import * as React from 'react';

interface SampleInteractionBottomNavProps
  extends Pick<InteractionBottomNavigationProps, 'tocTitle' | 'tocItems'> {
  seoData?: any;
}

export const SampleInteractionBottomNav = (props: SampleInteractionBottomNavProps) => {
  const { seoData, ...rest } = props;
  const { appScrollRef } = useAppScrollRef();

  return (
    <InteractionBottomNavigation
      layout="responsive"
      pageId={seoData?.id}
      pageUrl={seoData?.url}
      scrollContainerElm={appScrollRef.current}
      {...rest}
    />
  );
};
